<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-type" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :disabled="disabled"
      id="form-pass-type"
      class="show-tick form-control"
      @input="emit"
      @change="emit"
      @blur="emit"
    >
      <option v-for="subdivision in sortedItems" :key="subdivision.id" :value="subdivision.id">
        {{ subdivision.name }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TerminalSubdivisionInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  watch: {
    sortedItems: {
      handler(value) {
        if (Object.keys(value).length === 1) {
          this.inputValue = value[0].id
        }
      },
      immediate: true
    }
  },

  computed: {
    sortedItems() {
      return this.items
    }
  },

  props: {
    inputLabel: {
      default: 'Подразделение'
    },

    inputName: {
      default: 'subdivision_id'
    },

    inputHint: {
      default: undefined
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  }
}
</script>
